import { Component, input } from '@angular/core';
import { EnergyInterfaceState } from '../../stores/energy-interfaces.store';
import { NgIcon } from '@ng-icons/core';
import { Button } from 'excellence-ui';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-energy-interface-list-entry',
  imports: [NgIcon, Button, RouterLink, TranslocoPipe, NgClass],
  templateUrl: './energy-interface-list-entry.html',
})
export class EnergyInterfaceListEntry {
  energyInterface = input.required<EnergyInterfaceState>();
  organizationId = input.required<string>();
}
